import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderMenu = _resolveComponent("HeaderMenu")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Languages = _resolveComponent("Languages")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HeaderMenu),
    _createVNode(_component_router_view),
    _createVNode(_component_Languages, { class: "mt-4" })
  ]))
}